import * as types from '../const/action.types';

export function setInventoryWindow(value) {
    return {
        type: types.SET_INVENTORY_WINDOW,
        value,
    };
}



// WEBPACK FOOTER //
// ./src/actions/process.inventory.actions.js